import React, {Fragment, useState} from "react";
import {Icon_box_1, Icon_call_1, Icon_mail_1, Icon_user_card} from "../../../assets/icones/icones";
import {check_login_appbk, Get_Weight_txt_bk} from "../../../clientconfigwebapp";
import {NavLink} from "react-router-dom";
import Modal from "@mui/material/Modal";
import Grow from "@mui/material/Grow";
import Box from "@mui/material/Box";
import Call_Modal_Message from "../../../components/Call_Modal_Message/Call_Modal_Message";

const List_data_Show = (props) => {
    const [open, setOpen_modal_call] = useState(false);
    const [modal_info_get, Set_modal_info_get] = useState([]);
    const handle_modal_call_Open = (data_info_get) => {
        Set_modal_info_get(data_info_get);
        setOpen_modal_call(true);
    };
    const handle_modal_call_Close = () => {
        setOpen_modal_call(false);
    };

    /* modal_detail */
    const [open_modal_detail, setOpen_modal_detail] = useState(false);
    const [modal_detail_info_get, Set_modal_detail_info_get] = useState([]);
    const handle_modal_detail_Open = (data_info_get) => {
        Set_modal_detail_info_get(data_info_get);
        setOpen_modal_detail(true);
    };
    const handle_modal_detail_Close = () => {
        setOpen_modal_detail(false);
    };

    const style_modal_call = {
        position: 'absolute',
        top: '20%',
        left: '35%',
        transform: 'translate(-35%, -35%)',
        width: "35%",
        backgroundColor: 'white',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.1)',
        borderRadius: "10px",
    };

    return (
        <Fragment>
            <div>
                {props.data_list_posts && props.data_list_posts.length > 0 ? (
                    <Fragment>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                            {props.data_list_posts.map((item_post, index) => (


                                <div key={index} className={"bg-white  rounded-lg px-[15px] py-[10px]"}
                                     style={{"border": "1px solid #D1D5DB"}}>
                                    <span
                                        className="text-lg font-semibold mb-2 block">خریدار {item_post.title_post} هستم</span>

                                    <div className={"flex flex-col lg:flex-row gap-x-[3px]"}>
                                        <div className="flex flex-col w-full lg:w-[30%] justify-center items-start">


                                            <div className="flex gap-2 items-center text-[13px]">
                                                <Icon_user_card width={24} height={24}/>
                                                {String(item_post.first_name_post) + " " + String(item_post.last_name_post)}
                                            </div>



                                        </div>

                                        <div
                                            className="flex flex-row justify-end items-center w-full lg:w-[70%] gap-x-[8px]">
                                            <NavLink
                                                className="btn-bk-new btn-bk-new-blue-out flex items-center justify-center w-[50%] lg:w-[45%] !p-[9px] text-[13px]"
                                                to={check_login_appbk()
                                                    ? (item_post && item_post.id_ticket
                                                        ? `/panel/tickets/${String(item_post.id_ticket)}`
                                                        : '#')
                                                    : (item_post && item_post.id_ticket
                                                        ? `/login-register/?redirect=panel/tickets/${String(item_post.id_ticket)}`
                                                        : '#')
                                                }>
                                                <Icon_mail_1 width={25} height={24}/>
                                                <span className="text-blue-500">ارسال تیکت</span>
                                            </NavLink>

                                            <button
                                                type="button"
                                                onClick={() => handle_modal_call_Open(item_post)}
                                                className="btn-bk-new btn-bk-new-orange flex items-center justify-center w-[50%] lg:w-[45%] !p-[9px] text-[13px]"
                                            >
                                                <Icon_call_1 width={25} height={24}/>
                                                <span className="text-blue-500">تماس با خریدار</span>
                                            </button>
                                        </div>


                                    </div>

                                    <div className={" pt-[6px] mt-[9px] flex flex-row justify-between"}
                                         style={{"borderTop": "solid 1px #efefef"}}>

                                        <div className="flex items-center mt-2">
                                            <Icon_box_1 width={24} height={24}/>
                                            <span
                                                className="text-[13px] ml-2 pr-[4px]">مقدار مورد نیاز : {Get_Weight_txt_bk(String(item_post.order_amount))}</span>
                                        </div>
                                        <span className={"text-[#27a2c7] font-normal text-[13px] relative top-[9px] cursor-pointer hover:text-[black]"}
                                              onClick={() => handle_modal_detail_Open(item_post)}>توضیحات بیشتر</span>


                                    </div>


                                </div>


                            ))}
                        </div>
                    </Fragment>
                ) : (
                    <Fragment></Fragment>
                )}
            </div>

            {/* Modal for Call */}
            <Modal
                id="modal_call"
                open={open}
                onClose={handle_modal_call_Close}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableScrollLock={false}
                keepMounted={true}
                hideBackdrop={false}
                disablePortal={true}
                className="modal_muibk"
            >
                <Grow style={{transformOrigin: '0 0 0'}} {...(open ? {timeout: 1000} : {})} in={open}>
                    <Box className="box-modal-bkb" sx={style_modal_call}>
                        <div className="flex justify-between items-center border-b border-gray-300 px-5 py-2">
                            <span className="font-bold text-lg">اطلاعات تماس</span>
                            <span
                                className="text-gray-500 text-2xl cursor-pointer"
                                onClick={handle_modal_call_Close}
                            >X</span>
                        </div>
                        <div className="p-4">
                            <Call_Modal_Message modal_info_get={modal_info_get}/>
                        </div>
                    </Box>
                </Grow>
            </Modal>

            {/* Modal for Details */}
            <Modal
                id="modal_detail"
                open={open_modal_detail}
                onClose={handle_modal_detail_Close}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableScrollLock={false}
                keepMounted={true}
                hideBackdrop={false}
                disablePortal={true}
                className="modal_muibk"
            >
                <Grow style={{transformOrigin: '0 0 0'}} {...(open_modal_detail ? {timeout: 1000} : {})}
                      in={open_modal_detail}>
                    <Box className="box-modal-bkb" sx={style_modal_call}>
                        <div className="flex justify-between items-center border-b border-gray-300 px-5 py-2">
                            <span className="font-bold text-lg">اطلاعات تماس</span>
                            <span
                                className="text-gray-500 text-2xl cursor-pointer"
                                onClick={handle_modal_detail_Close}
                            >X</span>
                        </div>
                        <div className="p-4">
                            {modal_detail_info_get.description}
                        </div>
                    </Box>
                </Grow>
            </Modal>
        </Fragment>
    );
}

export default List_data_Show;
